import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { Vehicle } from "../Vehicle Management/VehicleManagement";
import {
  convertEpochtoDate,
  convertEpochToTime,
  removeSecFromDuration,
} from "../../../../helper/DateConverters";
import { Tooltip } from "primereact/tooltip";

export const tableHeaderTemplate = (
  header: string,
  field: string,
  setSortFilter?: any
) => {
  return (
    <div
      className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
        field !== "" && "tw-cursor-pointer"
      }`}
      onClick={() => {
        if (field !== "") {
          setSortFilter((prevSortFilter: any) => ({
            ...prevSortFilter,
            sortField: field,
            sortOrder: !prevSortFilter.sortOrder,
          }));
        }
      }}
    >
      <span className="tw-font-bold tw-text-[#141414]">{header}</span>
      {field !== "" && (
        <span className="tw-ml-4 tw-mr-0">
          <TableSortingSVG />
        </span>
      )}
    </div>
  );
};

export const actionBodyTemplate = (
  rowData: Vehicle,
  handleEdit: any,
  updateStatus: any,
  isAddButtonDisabled: boolean,
  formValues: any
) => (
  <div className="tw-flex tw-gap-4">
    <Button
      className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto"
      onClick={() => handleEdit(rowData)}
    >
      <EditButtonSVG />
    </Button>
    <InputSwitch
      checked={rowData.isActive}
      onChange={(e: InputSwitchChangeEvent) => {
        updateStatus(rowData.vehicleID, e.value);
      }}
      disabled={
        isAddButtonDisabled && rowData.vehicleID === formValues.vehicleID
      }
    />
  </div>
);

//Timelog Management Templates

export const accordianHeaderTemplate = (
  data: any,
  setShowExtendedTimesheet: any,
  isWorkerView: boolean
) => {
  return (
    <span className="tw-inline-flex tw-justify-between tw-items-center tw-gap-4 table-row-group-header">
      <span className="tw-inline-flex tw-flex-col">
        <span className="tw-text-[#64748B] tw-font-bold tw-text-sm">
          {isWorkerView ? data.name : data.vehicleRegistration}
        </span>
        <div className="tw-flex tw-gap-3">
          <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
            Total Claimed Time :{" "}
            <span className="tw-text-[#152846]">
              {data.appTime.totalTime}hrs
            </span>
          </span>
          <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
            Total Tracker Time :{" "}
            <span className="tw-text-[#00AFEE]">
              {data.trackerTime.totalTime}hrs
            </span>
          </span>
        </div>
      </span>
      <button
        type="button"
        className="tw-text-[#00AFEE] tw-font-bold tw-text-sm"
        onClick={() => setShowExtendedTimesheet(true)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z"
            fill="#00AFEE"
          />
        </svg>
      </button>
    </span>
  );
};

export const dateBodyTemplate = (rowData: any) => {
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      {/* {rowData.log_date === "08-01-2025" && <HolidayTreeSVG />} */}
      <span className="tw-text-[#64748B] tw-text-sm">
        {convertEpochtoDate(rowData.log_date)}
      </span>
    </span>
  );
};

export const appTimeBodyTemplate = (
  rowData: any,
  setShowTimeLogDetails: any,
  setTimeLogDetails: any
) => {
  // return <Tag value={rowData.status} severity={getSeverity(rowData.status)} />;
  return (
    <div className="tw-flex tw-align-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.punch_in && convertEpochToTime(rowData.punch_in)}
      </span>
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.punch_out && convertEpochToTime(rowData.punch_out)}
      </span>
      <span
        className="tw-text-[#152846] tw-font-bold tw-text-sm tw-cursor-pointer"
        onClick={() => {
          setTimeLogDetails(rowData.timelogdetails);
          setShowTimeLogDetails(true);
        }}
      >
        {/* {rowData.appTime.totalTime} */}
        {/* {rowData.punch_in &&
          (() => {
            const punchInTime = new Date(rowData.punch_in * 1000);
            const punchOutTime = new Date(rowData.punch_out * 1000);

            // Set both dates to the same day (e.g., January 1, 1970)
            punchInTime.setFullYear(1970, 0, 1);
            punchOutTime.setFullYear(1970, 0, 1);

            const timeDifferenceMs =
              punchOutTime.getTime() - punchInTime.getTime();
            
            const totalSeconds = timeDifferenceMs / 1000;
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = Math.floor(totalSeconds % 60);

            return `${
              rowData.punch_in
              ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
              : ""
            }`;
          })()} */}
        {rowData.punch_in &&
          (() => {
            const totalDuration = rowData.timelogdetails.reduce(
              (acc: any, curr: any) => {
                const [hours, minutes, seconds] = curr.duration
                  .split(":")
                  .map(Number);
                return acc + hours * 3600 + minutes * 60 + seconds;
              },
              0
            );

            const totalHours = Math.floor(totalDuration / 3600);
            const totalMinutes = Math.floor((totalDuration % 3600) / 60);
            // const totalSeconds = totalDuration % 60;

            // return (
            //   <span className="tw-underline">
            //     {`${String(totalHours).padStart(2, "0")}:${String(
            //       totalMinutes
            //     ).padStart(2, "0")}:${String(totalSeconds).padStart(2, "0")} hrs`}
            //   </span>
            // );
            return (
              <span className="tw-underline">
                {`${String(totalHours)}:${String(totalMinutes).padStart(
                  2,
                  "0"
                )} hrs`}
              </span>
            );
          })()}
      </span>
      {/* <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-cursor-pointer"
        onClick={() => setShowTimeLogDetails(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M12.375 10.6875H14.625C14.9234 10.6875 15.2095 10.569 15.4205 10.358C15.6315 10.147 15.75 9.86087 15.75 9.5625V7.3125C15.75 7.01413 15.6315 6.72798 15.4205 6.517C15.2095 6.30603 14.9234 6.1875 14.625 6.1875H12.375C12.0766 6.1875 11.7905 6.30603 11.5795 6.517C11.3685 6.72798 11.25 7.01413 11.25 7.3125V7.875H6.1875V5.625H6.75C7.04837 5.625 7.33452 5.50647 7.5455 5.2955C7.75647 5.08452 7.875 4.79837 7.875 4.5V2.25C7.875 1.95163 7.75647 1.66548 7.5455 1.4545C7.33452 1.24353 7.04837 1.125 6.75 1.125H4.5C4.20163 1.125 3.91548 1.24353 3.7045 1.4545C3.49353 1.66548 3.375 1.95163 3.375 2.25V4.5C3.375 4.79837 3.49353 5.08452 3.7045 5.2955C3.91548 5.50647 4.20163 5.625 4.5 5.625H5.0625V13.5C5.0625 13.9476 5.24029 14.3768 5.55676 14.6932C5.87322 15.0097 6.30245 15.1875 6.75 15.1875H11.25V15.75C11.25 16.0484 11.3685 16.3345 11.5795 16.5455C11.7905 16.7565 12.0766 16.875 12.375 16.875H14.625C14.9234 16.875 15.2095 16.7565 15.4205 16.5455C15.6315 16.3345 15.75 16.0484 15.75 15.75V13.5C15.75 13.2016 15.6315 12.9155 15.4205 12.7045C15.2095 12.4935 14.9234 12.375 14.625 12.375H12.375C12.0766 12.375 11.7905 12.4935 11.5795 12.7045C11.3685 12.9155 11.25 13.2016 11.25 13.5V14.0625H6.75C6.60082 14.0625 6.45774 14.0032 6.35225 13.8977C6.24676 13.7923 6.1875 13.6492 6.1875 13.5V9H11.25V9.5625C11.25 9.86087 11.3685 10.147 11.5795 10.358C11.7905 10.569 12.0766 10.6875 12.375 10.6875ZM4.5 2.25H6.75V4.5H4.5V2.25ZM12.375 13.5H14.625V15.75H12.375V13.5ZM12.375 7.3125H14.625V9.5625H12.375V7.3125Z" fill="#007AFF"/>
          </svg>
        </span> */}
    </div>
  );
};

export const trackerTimeBodyTemplate = (props: any) => {
  const isEdit =
    props.editTrackerTimeRowIndices &&
    props.editTrackerTimeRowIndices.includes(props.rowData.timeLogID);
  const handleEditClick = (id: any) => {
    if (isEdit) {
      props.setEditTrackerTimeRowIndices([]);
    } else {
      props.setEditTrackerTimeRowIndices([id]);
    }
  };

  return (
    <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full">
      <span className="tw-flex tw-gap-2">
        {isEdit ? (
          <Calendar
            value={props.time}
            onChange={(e) => props.setTime(e.value ?? null)}
            timeOnly
            className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px]"
          />
        ) : (
          <span className="tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12">
            {props.rowData.tracker_start &&
              convertEpochToTime(props.rowData.tracker_start)}
          </span>
        )}
      </span>
      <span className="tw-flex tw-gap-2">
        {isEdit ? (
          <Calendar
            value={props.time}
            onChange={(e) => props.setTime(e.value ?? null)}
            timeOnly
            className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px]"
          />
        ) : (
          <span className="tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12">
            {props.rowData.tracker_end &&
              convertEpochToTime(props.rowData.tracker_end)}
          </span>
        )}
      </span>
      <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-flex tw-items-center tw-w-7">
        {props.rowData.tracker_start &&
          // (() => {
          //   const totalDuration = props.rowData.timelogdetails.reduce(
          //     (acc: any, curr: any) => {
          //       const [hours, minutes, seconds] = curr.duration
          //         .split(":")
          //         .map(Number);
          //       return acc + hours * 3600 + minutes * 60 + seconds;
          //     },
          //     0
          //   );

          //   const totalHours = Math.floor(totalDuration / 3600);
          //   const totalMinutes = Math.floor((totalDuration % 3600) / 60);
          //   return `${String(totalHours)}:${String(totalMinutes).padStart(
          //     2,
          //     "0"
          //   )} hrs`;
          // })()}{" "}
          removeSecFromDuration(props.rowData.tracker_duration)}{" "}
        {props.rowData.tracker_duration && "hrs"}
      </span>
      {props.type === "teamLogs" ? (
        isEdit ? (
          <Button
            icon="pi pi-check"
            className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
            onClick={() => handleEditClick(props.rowData.timeLogID)}
          />
        ) : (
          <Button
            type="button"
            icon="pi pi-pencil"
            className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
            onClick={() => handleEditClick(props.rowData.timeLogID)}
          />
        )
      ) : null}
    </div>
  );
};

export const statusBodyTemplate = (
  rowData: any,
  setVisible: any,
  setSelectedRowData: any,
  setTimelogActivity: any,
  setViewHistoryPopup: any
) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <span className="a-badge tw-border-transparent">
        <span
          className={`dot ${
            rowData.status === "APPROVED"
              ? "bg-success"
              : rowData.status === "SUBMITTED TO MANAGER"
              ? "tw-bg-[#0255b0]"
              : rowData.status === "PENDING"
              ? "tw-bg-yellow-500"
              : rowData.status === "SUBMITTED"
              ? "tw-bg-[#25ccdb]"
              : rowData.status === "APPROVED BY MANAGER"
              ? "tw-bg-[#9e1c7f]"
              : rowData.status === "REJECTED"
              ? "tw-bg-red-500"
              : rowData.status === "REJECTED BY MANAGER"
              ? "tw-bg-red-500"
              : "tw-bg-black"
          }`}
        ></span>
        <span className="badge-value tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          {rowData.status}
        </span>
      </span>

      {/* Additional Icon */}
      <span
        className="tw-cursor-pointer tw-px-0 tw-py-1 tw-rounded"
        onClick={() => {
          setSelectedRowData(rowData);
          setVisible(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            opacity="0.2"
            d="M17.7666 9.99999C17.7668 11.3171 17.4201 12.6111 16.7614 13.7517C16.1027 14.8923 15.1552 15.8393 14.0143 16.4975C12.8734 17.1556 11.5792 17.5017 10.2621 17.5009C8.94496 17.5001 7.65126 17.1525 6.51113 16.493L3.59004 17.4672C3.47992 17.5039 3.36174 17.5092 3.24876 17.4826C3.13578 17.4559 3.03246 17.3983 2.95037 17.3162C2.86829 17.2341 2.81069 17.1308 2.78402 17.0178C2.75736 16.9049 2.76269 16.7867 2.79941 16.6766L3.77363 13.7555C3.19778 12.7594 2.8588 11.6442 2.78293 10.4962C2.70706 9.3482 2.89632 8.19811 3.33608 7.13494C3.77583 6.07178 4.4543 5.12404 5.31897 4.36505C6.18363 3.60607 7.21133 3.05619 8.32253 2.75796C9.43373 2.45973 10.5987 2.42115 11.7272 2.64521C12.8556 2.86926 13.9175 3.34994 14.8305 4.05005C15.7435 4.75016 16.4831 5.65094 16.9923 6.68268C17.5014 7.71442 17.7664 8.84947 17.7666 9.99999Z"
            fill="black"
          />
          <path
            d="M10.2667 1.875C8.8639 1.87469 7.48496 2.23757 6.26405 2.9283C5.04314 3.61904 4.02186 4.6141 3.29961 5.81664C2.57737 7.01918 2.17876 8.38822 2.14259 9.79052C2.10643 11.1928 2.43393 12.5806 3.09323 13.8188L2.20651 16.4789C2.13306 16.6992 2.1224 16.9355 2.17573 17.1615C2.22905 17.3874 2.34426 17.5941 2.50842 17.7582C2.67259 17.9224 2.87924 18.0376 3.1052 18.0909C3.33117 18.1443 3.56751 18.1336 3.78776 18.0602L6.44792 17.1734C7.53758 17.753 8.74496 18.0767 9.97841 18.12C11.2119 18.1633 12.439 17.925 13.5666 17.4232C14.6942 16.9215 15.6926 16.1694 16.4862 15.2241C17.2798 14.2789 17.8475 13.1652 18.1465 11.9678C18.4454 10.7703 18.4675 9.52047 18.2113 8.31315C17.9551 7.10584 17.4271 5.97276 16.6676 4.99993C15.9081 4.02711 14.9369 3.24009 13.8278 2.69864C12.7187 2.15718 11.5009 1.87551 10.2667 1.875ZM10.2667 16.875C9.05805 16.8758 7.87065 16.5575 6.82448 15.9523C6.72953 15.8973 6.62175 15.8682 6.51198 15.868C6.44474 15.868 6.37796 15.8791 6.31432 15.9008L3.39167 16.875L4.36588 13.9531C4.39397 13.8692 4.40389 13.7802 4.395 13.6921C4.38611 13.604 4.35861 13.5188 4.31432 13.4422C3.55649 12.132 3.25222 10.6083 3.44872 9.10747C3.64522 7.60667 4.3315 6.21267 5.40111 5.14171C6.47071 4.07076 7.86385 3.38271 9.3644 3.18431C10.8649 2.98592 12.389 3.28826 13.7002 4.04444C15.0114 4.80062 16.0364 5.96837 16.6162 7.36652C17.196 8.76468 17.2981 10.3151 16.9068 11.7773C16.5156 13.2394 15.6527 14.5316 14.4521 15.4533C13.2515 16.375 11.7803 16.8748 10.2667 16.875ZM11.2042 10C11.2042 10.1854 11.1492 10.3667 11.0462 10.5208C10.9432 10.675 10.7967 10.7952 10.6254 10.8661C10.4541 10.9371 10.2656 10.9557 10.0838 10.9195C9.90191 10.8833 9.73486 10.794 9.60375 10.6629C9.47264 10.5318 9.38335 10.3648 9.34718 10.1829C9.31101 10.001 9.32957 9.81254 9.40053 9.64123C9.47149 9.46993 9.59165 9.32351 9.74582 9.2205C9.89999 9.11748 10.0812 9.0625 10.2667 9.0625C10.5153 9.0625 10.7538 9.16127 10.9296 9.33709C11.1054 9.5129 11.2042 9.75136 11.2042 10ZM7.76667 10C7.76667 10.1854 7.71168 10.3667 7.60867 10.5208C7.50565 10.675 7.35924 10.7952 7.18793 10.8661C7.01663 10.9371 6.82813 10.9557 6.64627 10.9195C6.46441 10.8833 6.29736 10.794 6.16625 10.6629C6.03514 10.5318 5.94585 10.3648 5.90968 10.1829C5.87351 10.001 5.89207 9.81254 5.96303 9.64123C6.03399 9.46993 6.15415 9.32351 6.30832 9.2205C6.46249 9.11748 6.64375 9.0625 6.82917 9.0625C7.07781 9.0625 7.31626 9.16127 7.49208 9.33709C7.66789 9.5129 7.76667 9.75136 7.76667 10ZM14.6417 10C14.6417 10.1854 14.5867 10.3667 14.4837 10.5208C14.3807 10.675 14.2342 10.7952 14.0629 10.8661C13.8916 10.9371 13.7031 10.9557 13.5213 10.9195C13.3394 10.8833 13.1724 10.794 13.0413 10.6629C12.9101 10.5318 12.8209 10.3648 12.7847 10.1829C12.7485 10.001 12.7671 9.81254 12.838 9.64123C12.909 9.46993 13.0291 9.32351 13.1833 9.2205C13.3375 9.11748 13.5187 9.0625 13.7042 9.0625C13.9528 9.0625 14.1913 9.16127 14.3671 9.33709C14.5429 9.5129 14.6417 9.75136 14.6417 10Z"
            fill="black"
          />
        </svg>
      </span>

      {/* History Icons */}
      <span
        className="tw-cursor-pointer tw-px-0 tw-pt-[2px] tw-rounded"
        onClick={() => {
          setSelectedRowData(rowData);
          setTimelogActivity(rowData?.timelogHistoryDetails);
          setViewHistoryPopup(true);
        }}
      >
        <svg
          width="13"
          height="16"
          viewBox="0 0 13 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 9.6875H11.625C11.9234 9.6875 12.2095 9.56897 12.4205 9.358C12.6315 9.14702 12.75 8.86087 12.75 8.5625V6.3125C12.75 6.01413 12.6315 5.72798 12.4205 5.517C12.2095 5.30603 11.9234 5.1875 11.625 5.1875H9.375C9.07663 5.1875 8.79048 5.30603 8.5795 5.517C8.36853 5.72798 8.25 6.01413 8.25 6.3125V6.875H3.1875V4.625H3.75C4.04837 4.625 4.33452 4.50647 4.5455 4.2955C4.75647 4.08452 4.875 3.79837 4.875 3.5V1.25C4.875 0.951631 4.75647 0.665483 4.5455 0.454505C4.33452 0.243526 4.04837 0.125 3.75 0.125H1.5C1.20163 0.125 0.915483 0.243526 0.704505 0.454505C0.493526 0.665483 0.375 0.951631 0.375 1.25V3.5C0.375 3.79837 0.493526 4.08452 0.704505 4.2955C0.915483 4.50647 1.20163 4.625 1.5 4.625H2.0625V12.5C2.0625 12.9476 2.24029 13.3768 2.55676 13.6932C2.87322 14.0097 3.30245 14.1875 3.75 14.1875H8.25V14.75C8.25 15.0484 8.36853 15.3345 8.5795 15.5455C8.79048 15.7565 9.07663 15.875 9.375 15.875H11.625C11.9234 15.875 12.2095 15.7565 12.4205 15.5455C12.6315 15.3345 12.75 15.0484 12.75 14.75V12.5C12.75 12.2016 12.6315 11.9155 12.4205 11.7045C12.2095 11.4935 11.9234 11.375 11.625 11.375H9.375C9.07663 11.375 8.79048 11.4935 8.5795 11.7045C8.36853 11.9155 8.25 12.2016 8.25 12.5V13.0625H3.75C3.60082 13.0625 3.45774 13.0032 3.35225 12.8977C3.24676 12.7923 3.1875 12.6492 3.1875 12.5V8H8.25V8.5625C8.25 8.86087 8.36853 9.14702 8.5795 9.358C8.79048 9.56897 9.07663 9.6875 9.375 9.6875ZM1.5 1.25H3.75V3.5H1.5V1.25ZM9.375 12.5H11.625V14.75H9.375V12.5ZM9.375 6.3125H11.625V8.5625H9.375V6.3125Z"
            fill="#007AFF"
          />
        </svg>
      </span>
    </div>
  );
};

export const vehicleRegistrationTemplate = (
  rowData: any,
  vehiclesList: any,
  vehicleListLoading: boolean,
  editVehicleRowIndices: any,
  setEditVehicleRowIndices: any
) => {
  const isEdit = editVehicleRowIndices.includes(rowData.timeLogID);
  const handleEditClick = (id: any) => {
    if (isEdit) {
      setEditVehicleRowIndices(
        editVehicleRowIndices.filter((index: any) => index !== id)
      );
    } else {
      setEditVehicleRowIndices([...editVehicleRowIndices, id]);
    }
  };
  return (
    <div className="tw-flex tw-items-center tw-gap-3">
      <span>{rowData.vehicleRegistration}</span>
      {isEdit ? (
        <>
          <Dropdown
            value={""}
            onChange={(e) => console.log(e.value)}
            options={vehiclesList}
            optionLabel="registration_no"
            placeholder="Select Vehicle"
            loading={vehicleListLoading}
            className="small-dropdown tw-border tw-border-solid tw-py-0 tw-border-[#D0D5DD]"
          />
          <Button
            icon="pi pi-times"
            className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
            onClick={() => handleEditClick(rowData.timeLogID)}
          />
        </>
      ) : (
        <Button
          type="button"
          icon="pi pi-pencil"
          className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
          onClick={() => handleEditClick(rowData.timeLogID)}
        />
      )}
    </div>
  );
};

export const projectNameBodyTemplate = (rowData: any) => {
  return (
    // <span className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4">
    <span className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-w-[340px] tw-max-w-[340px] tw-min-w-[340px] tw-text-wrap">
      {rowData.projectName} - {`( ${rowData.projectKey} )`}
    </span>
  );
};

export const appTimeLogBodyTemplate = (rowData: any) => {
  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-max-w-[320px] tw-min-w-[320px]">
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {convertEpochToTime(rowData.start_time)}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          Start Time
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {convertEpochToTime(rowData.end_time)}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          End Time
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {/* {(() => {
            const punchInTime = new Date(rowData.start_time * 1000);
            const punchOutTime = new Date(rowData.end_time * 1000);

            // Set both dates to the same day (e.g., January 1, 1970)
            punchInTime.setFullYear(1970, 0, 1);
            punchOutTime.setFullYear(1970, 0, 1);

            const timeDifferenceMs =
              punchOutTime.getTime() - punchInTime.getTime();
              const totalSeconds = timeDifferenceMs / 1000;
              const hours = Math.floor(totalSeconds / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);
              const seconds = Math.floor(totalSeconds % 60);
  
              return `${
                rowData.start_time
                ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
                : ""
              }`;
            })()} */}
          {rowData.duration}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          Total Hours
        </span>
      </div>
    </div>
  );
};

export const managerTimeBodyTemplate = (rowData: any) => {
  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-max-w-[320px] tw-min-w-[320px]">
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {rowData.manager_start_time
            ? convertEpochToTime(rowData.manager_start_time)
            : "--:--"}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          Start Time
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {rowData.manager_end_time
            ? convertEpochToTime(rowData.manager_end_time)
            : "--:--"}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          End Time
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-items-start">
        <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
          {/* {(() => {
            const punchInTime = new Date(rowData.start_time * 1000);
            const punchOutTime = new Date(rowData.end_time * 1000);

            // Set both dates to the same day (e.g., January 1, 1970)
            punchInTime.setFullYear(1970, 0, 1);
            punchOutTime.setFullYear(1970, 0, 1);

            const timeDifferenceMs =
              punchOutTime.getTime() - punchInTime.getTime();
              const totalSeconds = timeDifferenceMs / 1000;
              const hours = Math.floor(totalSeconds / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);
              const seconds = Math.floor(totalSeconds % 60);
  
              return `${
                rowData.start_time
                ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
                : ""
              }`;
            })()} */}
          {rowData.manager_duration
            ? removeSecFromDuration(rowData.manager_duration)
            : "--:--"}
        </span>
        <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
          Total Hours
        </span>
      </div>
    </div>
  );
};

export const descriptionBodyTemplate = (rowData: any) => {
  return (
    // <p
    //   // className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 description-tooltip-target"
    //   className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-break-words tw-whitespace-normal"
    //   data-pr-tooltip={`dfhdfhdf`}
    // >
    //   {rowData.description}
    // </p>
    <>
      <Tooltip
        target=".in-project-desc"
        mouseTrack
        mouseTrackLeft={10}
        position="bottom"
        className="tw-max-w-sm tw-text-sm"
      />
      {/* <div className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-break-words tw-whitespace-normal">
            {rowData.description}
          </div> */}
      {rowData.description && (
        <span
          className="tw-ml-2 in-project-desc"
          data-pr-tooltip={
            rowData.description.length > 40 ? rowData.description : undefined
          }
        >
          {rowData.description.length > 40
            ? `${rowData.description.substring(0, 40)}......`
            : rowData.description}
        </span>
      )}
    </>
  );
};

export const myLogsTrackerTimeBodyTemplate = (rowData: any) => {
  return (
    <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full">
      <span className="tw-flex tw-gap-2">
        <span className="tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12">
          {rowData.trackerTime.startTime}
        </span>
      </span>
      <span className="tw-flex tw-gap-2">
        <span className="tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12">
          {rowData.trackerTime.endTime}
        </span>
      </span>
      <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-flex tw-items-center tw-w-7">
        {rowData.trackerTime.totalTime}
      </span>
    </div>
  );
};
